import { useEffect, useState } from "react"
import { getCollectedCards } from "../tools/CardTools";
import PlayerCards from "../components/PlayerCards";

export const CollectedCards = () => {
    const [collectedCards, setCollectedCards] = useState([]);
    useEffect(() => {
        if (!localStorage.getItem("token")) {
            window.location.href = "/";
        }
        getCollectedCards().then(data => {
            setCollectedCards(data.collectedCards);
        })
    }, []);
    return (<div style={{marginTop:"18px"}}><PlayerCards size="sm" collectedCards={collectedCards} /></div>)
}